import { OrdersTable } from "../orders/OrdersTable";

interface OrdersProps {
  symbol: string;
}

export const Orders = ({ symbol }: OrdersProps) => {
  return (
    <OrdersTable
      symbol={symbol}
      hideFilters
      defaultPageSize={5}
      persistenceKey="orders-table-trade-page"
    />
  );
};

export default Orders;
